import apiRegis from '@/api/vo/registration';

const defaultState = () => ({
	mitraName: {},
	mitraData: {},
	responSuksesRegis: {},
	responseError: {},
	konfirmResponse: {},
	errorValidation: []
});

const state = defaultState();

const getters = {};

const mutations = {
	setMitraName(state, data) {
		state.mitraName = data.data;
	},
	setMitraData(state, data) {
		state.mitraData = data.data;
	},
	saveResponseError(state, data) {
		state.responseError = data;
	},
	setSuksesRegis(state, data) {
		state.responSuksesRegis = data
	},
	saveConfirmResponse(state, data) {
		state.konfirmResponse = data;
	},

	setErrorValidation(state, data) {
		state.errorValidation = data
	},
};

const actions = {

	async getMitraByNetworkCode({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiRegis.getMitraByNetworkCode(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					resolve(data.results)
				} else {
					resolve(data.results)
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, data mitra tidak dapat ditampilkan.'
				}, { root: true });
				reject()
			});
		});
	},

	async getMitraByIdentityNum({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiRegis.getMitraByIdentityNum(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					resolve(data.results)
					commit('setMitraData', data);
				} else {
					resolve(data)
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setMitraData', {});
			});
		});
	},

	async getMitraIdentityUsed({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiRegis.getMitraIdentityUsed(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setMitraData', data.results);
					resolve(data.results)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setMitraData', {});
			});
		});
	},

	addPraMitra({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiRegis.addPraMitra(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					dispatch('success', data)
					commit('setSuksesRegis', data.results.data );
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, registrasi mitra tidak dapat diproses.'
				}, { root: true });
				commit('setSuksesRegis', { data: {} });
				reject()
			});
		});
	},

	addRegistration({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiRegis.addRegistration(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					dispatch('success', data)
					commit('setSuksesRegis', data.results.data );
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, registrasi mitra tidak dapat diproses.'
				}, { root: true });
				commit('setSuksesRegis', { data: {} });
				reject()
			});
		});
	},
	
	addCloneMitra({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiRegis.addCloneMitra(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					dispatch('success', data)
					commit('setSuksesRegis', data.results.data );
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, registrasi mitra tidak dapat diproses.'
				}, { root: true });
				commit('setSuksesRegis', { data: {} });
				reject()
			});
		});
	},
	
	addActivation({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiRegis.addActivation(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					dispatch('success', data)
					commit('setSuksesRegis', data.results.data[0] );
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch((err) => {
				const data = err.response.data.data
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, aktivasi mitra tidak dapat diproses.'
				}, { root: true });
				commit("saveConfirmResponse", data);
				reject()
			});
		});
	},

	addActivationMitra({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiRegis.addActivationMitra(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					dispatch('success', data)
					commit('setSuksesRegis', data.results.data[0] );
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch((err) => {
				const data = err.response.data.data
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, aktivasi mitra tidak dapat diproses.'
				}, { root: true });
				commit("saveConfirmResponse", data);
				reject()
			});
		});
	},

	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},

	errorHandler({ commit }, response) {
		if (response.status !== undefined && response.status === 'unauthorized') {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.msg
			}, { root: true });
		} else {
			switch (response.error_code) {
				case 'validationError':
					commit('setErrorValidation', response.results.validationMessage)
					break;
					
				case 'ERROR':
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: response.message
					}, { root: true });
					break;
						
				default:
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: 'Terjadi Kesalahan pada sistem, hubungi administrator atau layanan mitra ' + (process.env.VUE_APP_CLIENT_INIT !== undefined) ? process.env.VUE_APP_CLIENT_INIT : 'perusahaan'
					}, { root: true });
					break;
			}
		}
	},

	resetValidation({ commit }) {
		commit('setErrorValidation', [])
	}

};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};